/**
 * Constants for identifying React components
 */
export class ComponentIds {
  public static NORA_APP_HEADER_ID = 'AppHeaderId';
}
